import { IOtpVerifyProps, IOtpVerifyResponse } from '@services/hooks/checksAndVerification/index';
import { IQueryResponse } from '@services/api';
import { ToastType, useTosterStore } from '@store/toster';
import { APIService } from '@services/api/common-services';
import { APICONFIG } from '@config/api.config';
import { ErrorHandler } from '@helper/errorHandler';
import { useQuery } from '@tanstack/react-query';

export const UseOtpVerifyService = (props: IOtpVerifyProps): IQueryResponse<IOtpVerifyResponse> => {
	const { membership_number, site_visit_id, phone_number, otp, longitude, latitude } = props;
	const { setToaster } = useTosterStore();
	const submitOtpDetails = async (): Promise<IOtpVerifyResponse> => {
		try {
			return await APIService.postData<IOtpVerifyResponse>(APICONFIG.VERIFY_SITE_OTP, {
				membership_number: membership_number,
				site_visit_id: site_visit_id,
				phone_number: phone_number,
				otp: otp,
				latitude: latitude,
				longitude: longitude,
			});
		} catch (error) {
			const errMessage = new Error(error as string);
			setToaster(true, ToastType.error, errMessage.message);
			ErrorHandler(error);
			throw error;
		}
	};

	const { data, error, isLoading, isPending, isFetching, refetch } = useQuery({
		queryKey: ['otpDetails'],
		queryFn: submitOtpDetails,
		enabled: false,
		refetchOnWindowFocus: false,
		gcTime: 0,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
		refetch,
	};
};
